import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import { endOfWeek, format, startOfWeek } from 'date-fns';
import { colorScheme } from '@ugo/data';
import { useUtilities } from '@ugo/utils';

export const ConversionsPerWeekLineChart = ({
  reservations,
  startDate,
  endDate,
}: {
  reservations: any[];
  startDate: Date | null;
  endDate: Date | null;
}) => {
  const { groupServiceCountByWeek } = useUtilities();
  const [graphData, setGraphData] = useState<Array<number[]>>([]);
  const [weeks, setWeeks] = useState<string[]>([]);

  useEffect(() => {
    const { weeks, servicesByWeeks } = groupServiceCountByWeek(
      reservations,
      [],
      startDate,
      endDate
    );

    // @ts-ignore
    setWeeks(weeks);
    setGraphData([
      // @ts-ignore
      servicesByWeeks,
    ]);
  }, [reservations, startDate, endDate]);

  return (
    <Line
      data={{
        labels: weeks.map((w) => {
          const date = new Date(w);
          const weekStart = startOfWeek(date, { weekStartsOn: 1 });
          const weekEnd = endOfWeek(date, {
            weekStartsOn: 1,
          });

          return `${format(weekStart, 'dd/MM')} - ${format(weekEnd, 'dd/MM')}`;
        }),
        datasets: [
          {
            label: 'First reservations',
            data: graphData[0],
            lineTension: 0,
            pointRadius: 5,
            borderColor: colorScheme[0],
            backgroundColor: 'transparent',
          },
        ],
      }}
      options={{
        title: {
          display: true,
          text: 'Conversions per week',
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                precision: 0,
                beginAtZero: true,
                min: 0,
              },
            },
          ],
        },
      }}
    />
  );
};
